import { useFileDownload } from "../components/Common/useFileDownload";
import { DwellTimeParams, formatDwellTimeQuery } from "../components/Requests/useGetDwellTime";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export const useDownloadDwellTime = (params: DwellTimeParams) => {
  const business = useSelectedBusiness();

  return useFileDownload(formatDwellTimeQuery(business.id, params), 'dwellTime.csv');
}
